export default __webpack_public_path__ + "static/Enforcer-b44225e43dbae4f1bc3d7b10949c8623.png";